import { render, staticRenderFns } from "./externalContactsInput.vue?vue&type=template&id=d5fbc60c&scoped=true&"
import script from "./externalContactsInput.vue?vue&type=script&lang=ts&"
export * from "./externalContactsInput.vue?vue&type=script&lang=ts&"
import style0 from "./externalContactsInput.vue?vue&type=style&index=0&id=d5fbc60c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fbc60c",
  null
  
)

export default component.exports